import React from "react";
import {
  CancelButton,
  ContainerButtons,
  ContentPhotos,
  PhotoAvatar,
  SaveButton,
} from "./AvatarPhoto.styled";
import PropTypes from "prop-types";

const AvatarPhoto = ({
  handleSavePhoto,
  photoSelected,
  setPhotoSelected,
  photosavatar,
  setOpenModalProfile,
}) => {
  return (
    <>
      <ContentPhotos>
        {Array.isArray(photosavatar) && photosavatar.map((p) => {
          return (
            <PhotoAvatar
              key={p.name}
              onClick={() => setPhotoSelected(p)}
              photo={`${p.url}`}
              name={`${p.name.replace("UserProfilePicture/", "")}`}
              photoSelected={`${photoSelected?.name ? photoSelected.name : photoSelected.imageName}`}
            ></PhotoAvatar>
          );
        })}
      </ContentPhotos>
      <ContainerButtons>
        <CancelButton onClick={() => setOpenModalProfile(false)}>Cancel</CancelButton>
        <SaveButton onClick={() => handleSavePhoto()}>Save</SaveButton>
      </ContainerButtons>
    </>
  );
};

export default AvatarPhoto;

AvatarPhoto.propTypes = {
  handleSavePhoto: PropTypes.func,
  photoSelected: PropTypes.string,
  setPhotoSelected: PropTypes.func,
  photosavatar: PropTypes.array,
  setOpenModalProfile: PropTypes.func,
};